// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Spinner_spinnerWrapper__viZoS","spinner":"Spinner_spinner__0MYcd","spin":"Spinner_spin__jnriF","spinnerText":"Spinner_spinnerText__2VMsU"};